import { version } from "../../../package.json";

export default function() {
  return {
    appVersion: version || "0.0.0",
    user: {
      profile: {},
      access_token: null
    },
    company: {},
    userSettings: null,
    companySettings: null,
    departments: null,
    warehouses: null,
    locations: null,
    projects: null,
    vatTypes: null,
    currencies: null,
    suppliers: null,
    accounts: null,
    dimensionSettings: null,
    dimensions: null,
    lastFileImportTime: null
  };
}
